import type React from 'react';

import { Text } from '@change/ds-core-ui';

import { Translate } from '@change-corgi/core/react/i18n';

export const Footer: React.FC = () => {
	return (
		<div className="text-typography-strong mt-4 text-center">
			<Text size="small" data-qa="ppmu-modal-footer-text">
				<Translate value="corgi.co.ppmu.modal.footer_text" />
			</Text>
		</div>
	);
};
